import { useLayoutEffect, useRef } from "react";

const KEYBOARD_MIN_HEIGHT = 100;

// Mobile browsers shrink only the visual viewport when the on-screen keyboard
// opens, so `dvh`-sized, fixed layouts end up partly behind it.
export const useKeyboardAvoidingLayout = (enabled: boolean) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const viewport = window.visualViewport;
    const element = ref.current;
    if (!enabled || !viewport || !element) return;

    const clear = () => {
      element.style.height = "";
      element.style.transform = "";
    };

    const sync = () => {
      const isKeyboardOpen =
        viewport.scale === 1 &&
        window.innerHeight - viewport.height > KEYBOARD_MIN_HEIGHT;

      if (!isKeyboardOpen) {
        clear();
        return;
      }

      element.style.height = `calc(${viewport.height}px - env(safe-area-inset-top, 0px))`;
      element.style.transform = `translateY(${viewport.offsetTop}px)`;
    };

    sync();
    viewport.addEventListener("resize", sync);
    viewport.addEventListener("scroll", sync);

    return () => {
      viewport.removeEventListener("resize", sync);
      viewport.removeEventListener("scroll", sync);
      clear();
    };
  }, [enabled]);

  return ref;
};
